import { render, staticRenderFns } from "./InputCategory.vue?vue&type=template&id=875ee8d6&scoped=true&"
import script from "./InputCategory.vue?vue&type=script&lang=js&"
export * from "./InputCategory.vue?vue&type=script&lang=js&"
import style0 from "./InputCategory.vue?vue&type=style&index=0&id=875ee8d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875ee8d6",
  null
  
)

export default component.exports